export const meta = {
  slug: {
    de: "digitalisierung-arztpraxis-leitfaden",
    en: "medical-practice-digitalization-guide",
  },
  title: "Digitalisierung der Arztpraxis: ein ruhiger Leitfaden",
  excerpt:
    "Wie eine Arztpraxis Schritt für Schritt digitalisiert wird, ohne den Alltag zu überfordern – mit Fokus auf weniger Verwaltung und mehr Zeit für Patienten.",
  category: "praxen",
  publishedAt: "2026-06-15",
  metaTitle: "Digitalisierung Arztpraxis: Leitfaden 2026 | OnePractix",
  metaDescription:
    "Arztpraxis digitalisieren: ruhiger Leitfaden in vier Phasen – Website, Online-Terminvergabe und Telefon. Weniger Verwaltung, mehr Zeit für Patienten.",
  related: [
    "praxisorganisation-verbessern",
    "praxiswebsite-was-patienten-wirklich-suchen",
    "telefonservice-praxis-sinnvoll",
  ],
  en: {
    title: "Medical practice digitalization: a calm, practical guide",
    metaTitle: "Medical practice digitalization: a guide | OnePractix",
    metaDescription:
      "How to digitalize a medical practice step by step — website, online booking and phone — with focus on less admin and more time for patients.",
    excerpt:
      "A step-by-step guide to digitalizing a medical practice without overloading the team — focused on less admin and more time for patients.",
  },
};

export default meta;